import { doc, getDoc } from 'firebase/firestore'
import { db } from '@/firebase'

// serviceProviders is intentionally absent: provider catalogs are code
// defaults + district/school-scoped overrides, not global-doc fields.
const REQUIRED_KEYS = ['grades', 'numPeriods', 'classServices']

// Read-only: app_settings/global loads and carries the fields the UI needs.
export default {
  id: 'appSettings',
  label: 'App settings',
  description: 'app_settings/global is readable and has required fields.',
  destructive: false,

  async run(ctx, step) {
    let settings
    await step('read app_settings/global', async () => {
      const snap = await getDoc(doc(db, 'app_settings', 'global'))
      if (!snap.exists()) throw new Error('app_settings/global does not exist')
      settings = snap.data()
      return `${Object.keys(settings).length} top-level keys`
    })

    await step('required fields present', async () => {
      const missing = REQUIRED_KEYS.filter((k) => settings[k] == null)
      if (missing.length) throw new Error(`Missing: ${missing.join(', ')}`)
      return REQUIRED_KEYS.join(', ')
    })
  }
}
